<full-calendar #calendar [options]="calendarOptions" [events]="calendarEvents">
  <!-- <ng-template #eventContent let-arg>
    <b>{{ arg.timeText }}</b>
    <i>{{ arg.event.title }}</i>
  </ng-template> -->
</full-calendar>
